import React from "react"
import { FaInstagram } from "react-icons/fa"

export default function Footer() {
  return (
    <footer className="max-w-7xl w-11/12 2xl:w-full mx-auto py-2 border-t">
      <div className="flex flex-col md:flex-row justify-between items-center text-xs flex-wrap gap-2">
        <div>
          © <a href="/">IALIGN</a>, {new Date().getFullYear()} All rights
          reserved
        </div>
        <div className="flex gap-8 items-center ">
          <span className="font-bold text-stone-600">Follow Us</span>
          <ul className="flex gap-5 relative before:absolute before:w-4 before:h-px before:bg-stone-500 before:left-[-22px] before:top-1/2">
            {[
              {
                icon: <FaInstagram />,
                link: "https://www.instagram.com/ialign.biz/",
              },
            ].map((li, key) => {
              return (
                <li
                  key={key}
                  className="h-8 w-8 text-white bg-stone-500 rounded-full flex items-center justify-center"
                >
                  <a href={li.link} target="_blank" rel="noreferrer">
                    {li.icon}
                  </a>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </footer>
  )
}
